import { render, staticRenderFns } from "./ContaContabilListagem.vue?vue&type=template&id=48530b7e&"
import script from "./ContaContabilListagem.vue?vue&type=script&lang=js&"
export * from "./ContaContabilListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports